import { FC } from "react"
import { Account } from "./Account"
import { SquareWrapper } from "~/contexts/SquareWrapper"

export const AccountPage: FC = () => {
	return (
		<SquareWrapper>
			<Account />
		</SquareWrapper>
	)
}
